import React, { Component } from 'react';
import cs from 'classnames';
import css from './style.css';

class IconItem extends Component {
  render() {
    const { total } = this.props;
    return (
      <span
        className={cs(css.iconCol, {
          [css.RedCol]: total >= 2000,
          [css.OraCol]: (total < 2000) & (total > 1000),
          [css.GreCol]: (total < 1000) & (total > 500),
          [css.BulCol]: (total < 500) & (total >= 100),
          [css.SkyCol]: total < 100,
        })}></span>
    );
  }
}

export default class ListItem extends Component {
  constructor(props) {
    super(props);
    this.hideNumberRender = this.hideNumberRender.bind(this);
  }

  hideNumberRender(num) {
    return <span className={css.itemOrigin}>**{num % 10}</span>;
  }

  render() {
    const { state, inbound, isMember = false, intrastate, outbound, itemClickhandel, isActice } = this.props;
    const total = parseInt(inbound) + parseInt(intrastate) + parseInt(outbound);
    return (
      <div className={cs(css.ListItemWrap,{[css.ActiveItem]: isActice})} onClick={itemClickhandel} >
        <div className={css.itemIcon}>
          <IconItem total={total} /> {state}
        </div>
        {isMember ? (
          <div className={css.itemOrigin}>{inbound}</div>
        ) : (
          this.hideNumberRender(inbound)
        )}
        {isMember ? (
          <div className={css.itemOrigin}>{intrastate}</div>
        ) : (
          this.hideNumberRender(intrastate)
        )}
        {isMember ? (
          <div className={css.itemOrigin}>{outbound}</div>
        ) : (
          this.hideNumberRender(outbound)
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/compontents/RatioList/ListItem/index.js